/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import Footer from "../components/main/Footer"
import { Topbar } from "../components/organisms/Topbar"
import { TENANTS } from "../constants"
import { changeToCapitalLetter, initPdiComponent } from "../core/service/BusinessLogicService"
import { isPdiRetailTenant, loc } from "../core/utils"
import React, { Component } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"

class PaymentKOPage extends Component {
  state: {}

  getOrderCanceledMessage() {
    return this.props?.tunnelData?.tenant === TENANTS.MEDIAMARKT_NL
      ? "Je bestelling is geannuleerd."
      : loc`Your order is canceled. The amount of the upfront will not be deducted from you.`
  }

  componentDidMount() {
    initPdiComponent("PaymentKoPage")
  }

  render() {
    return (
      <Container fluid>
        <Row noGutters>
          <Col className="misc-block">
            <Row>
              <Topbar tunnelData={this.props?.tunnelData} displayToggleButton={false} history={this.props?.history} />

              <Col sm={12}>
                {/* CONTENT */}
                <Container>
                  <Row className="justify-content-center">
                    <Col xs={11} sm={10} md={10} lg={6} className="hard-shadow-white-block text-center misc-mono-block">
                      <span className="ico-danger-background">
                        <i className="far fa-times"></i>
                      </span>
                      <h1>{loc`Operation failed`}</h1>
                      <p>
                        <strong>{this.getOrderCanceledMessage()}</strong>
                      </p>
                      <p>
                        {changeToCapitalLetter(this.props?.tunnelData?.title)} {loc`thanks you for your request.`}
                      </p>
                      <Button
                        href={
                          isPdiRetailTenant(this.props.tunnelData?.tenant)
                            ? `${this.props?.tunnelData?.pdiRetailUrl}home`
                            : this.props?.tunnelData?.shopUrl
                        }
                        variant="primary"
                        className="ico-back-small-before"
                      >
                        {loc`Back to shop`}
                      </Button>
                    </Col>
                  </Row>
                </Container>
                {/* END CONTENT */}
              </Col>
              <Col sm={12}>
                <Container>
                  <Footer tunnelData={this.props?.tunnelData} />
                </Container>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default PaymentKOPage
